export function formatLargeNum(num : number) {
    if (num < 1000) {return num;}
    
}

export function getQuarter(m: number):number {
    
    let quarter:number;

    switch (m) {
        case 1:
            quarter = 4;
            break;
        case 2:
            quarter = 1;
            break;
        case 3:
            quarter = 1;
            break;
        case 4:
            quarter = 1;
            break;
        case 5:
            quarter = 2;
            break;
        case 6:
            quarter = 2;
            break;
        case 7:
            quarter = 2;
            break;
        case 8:
            quarter = 3;
            break;
        case 9:
            quarter = 3;
            break;
        case 10:
            quarter = 3;
            break;
        case 11:
            quarter = 4;
            break;
        case 12:
            quarter = 4;
            break;
        default:
            quarter = 0;
    }
    return quarter;

};

export function getFiscalYear(m: number):number {

    var currentTime = new Date();
    return currentTime.getMonth() === 1 ? currentTime.getFullYear()%100 : currentTime.getFullYear()%100 + 1;
}

export function stringConverter(value : number|string):string {

    return typeof value === "number" ? value.toString() : value;
}